import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/438'

const TopFiftyCustomersTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="users.user_list.tabs.top_50_customers"
  />
)

export default TopFiftyCustomersTab
